module.exports = __webpack_public_path__ + "img/03-10.8e695742.png";